import { Dialog } from "primereact/dialog"

export const EndTestDialog = ({ endTestDialog, setEndTestDialogHandler, endTestHandler, resumeTestHandler, totalQuestions, answeredQuestions, testType }: any) => {
  return (
    <>
      <Dialog className="mock-test-dialog-box" position="top" visible={endTestDialog} onHide={() => setEndTestDialogHandler(false)} closeOnEscape={false} >
        <div className="pause-dialog-box">
          <div className="p-dlg-heading">End Test?</div>
          <div className="p-dilg-para">Do you really want to end the test?</div>
          {testType === 1 && (totalQuestions - answeredQuestions) > 0 && (
            <p className="p-dilg-para" style={{ marginTop: '5px', color: '#666', fontSize: '14px' }}>
              Remaining Questions: {totalQuestions - answeredQuestions}
            </p>
          )}

          <div className="tw-mt-7 tw-flex gap-3 tw-justify-center">
            <button className="ia-btn ia-btn-outline-primary"
              onClick={() => endTestHandler()} > End Test</button>
            <button className="ia-btn ia-btn-primary" onClick={() => resumeTestHandler()}>Resume Test</button>
          </div>
        </div>
      </Dialog>
    </>
  )
}
